import axios from "axios"
import * as XLSX from 'xlsx';

import AiAgentService from "@/services/cis-aiagent.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

const boldStyle = { font: { name: 'Consolas', bold: true } };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

export default class ExpXlInsight {
  constructor() {
    XLSX = require("xlsx-js-style");
  }

  newSheet4CDJ(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '키워드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) { 
      if (data[idx].cdj == 'Total') {
        tmp_sheet.push([])
        tmp_sheet.push(['',
                        { v: data[idx].cdj, t: "s", s: stringStyle }, 
                        { v: Math.round(data[idx].freq), t: "n", s: intNumStyle },
                        { v: 1, t: "n", s: rateNumStyle }
                      ]);
      }
      else {
        tmp_sheet.push([{ v: Number(idx) + 1, t: "n", s: indexNumStyle }, 
                        { v: data[idx].cdj, t: "s", s: stringStyle }, 
                        { v: Math.round(data[idx].freq), t: "n", s: intNumStyle },
                        { v: 1, t: "n", s: rateNumStyle }
                      ]);         
      }
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4BrandShare(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '키워드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    var totalFreq = 0;
    var totalRate = 0;

    for (const idx in data) {         
      var tmp_row = [];

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});             // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});             // 키워드
      tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});        // 검색량
      tmp_row.push({t: "n", v: Number(data[idx].rate) / 100, s: rateNumStyle}); // 비율        

      tmp_sheet.push(tmp_row)

      totalFreq += data[idx].freq;
      totalRate += data[idx].rate;
    }

    tmp_sheet.push([]);
    tmp_sheet.push(['', 
                    {t: "s", v: 'Total', s: stringStyle}, 
                    {t: "n", v: Number(totalFreq), s: intNumStyle}, 
                    {t: "n", v: Number(totalRate) / 100, s: rateNumStyle}
                    ]);
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4StackedInsight(columns, data) {
    var tmp_sheet = [];
    var merge_info = [];

    var row_cnt = 0;

    // Group & Header 
    var group_header = [''];
    var header_list = ['No.']

    var col_st = group_header.length;
    var col_en = col_st;

    for (const group of columns[0]) {
      group_header.push({ v: group, t: "s", s: boldStyle })
      col_en++

      for (let i = 0; i < columns[1].length; i++) {
        if (i < columns[1].length - 1) {
          group_header.push({ v: "", t: "s", s: boldStyle })
          col_en++
        }

        header_list.push(columns[1][i]);
      }

      merge_info.push({
        s: { r: row_cnt, c: col_st}, e: { r: row_cnt, c: col_en - 1}
      })

      col_st = col_en
    }

    tmp_sheet.push(group_header);

    // Header     
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) {         
      var tmp_row = [];

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});                 // No.

      for (let i = 0; i < 10; i++) {
        tmp_row.push({t: "s", v: data[idx][0][i], s: stringStyle});                 // 속성
        tmp_row.push({t: "n", v: Number(data[idx][1][i]), s: floatNumStyle});       // 검색량
        tmp_row.push({t: "n", v: Number(data[idx][2][i]) / 100, s: rateNumStyle});  // 비율 
      }

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)
    ws['!merges'] = merge_info

    return ws;
  }

  newSheet4TopRankKeywords(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '키워드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) {         
      var tmp_row = [];

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});                           // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});                           // 키워드
      tmp_row.push({t: "n", v: Number(data[idx].freq.replaceAll(',', '')), s: intNumStyle});  // 검색량
      tmp_row.push({t: "s", v: data[idx].brand, s: stringStyle});                             // 브랜드 

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  async xlExport(cat_id, st_dt, en_dt, dataset) {
    if (dataset.length == 0) 
      return ""

    const workbook = XLSX.utils.book_new()	// 엑셀 생성

    for (const sheet of dataset) {
      const sheet_nm = sheet.sheet_nm.replace(/[\/]/g, '').trim().substring(0, 31)

      switch (sheet.sheet_type) {
        case 0:
            XLSX.utils.book_append_sheet(workbook, 
                                          this.newSheet4CDJ(sheet.cat, sheet.data), 
                                          sheet_nm)
            break
        case 1:
            XLSX.utils.book_append_sheet(workbook, 
                                          this.newSheet4BrandShare(sheet.cat, sheet.data), 
                                          sheet_nm)
            break
        case 2:
            XLSX.utils.book_append_sheet(workbook, 
                                          this.newSheet4StackedInsight(sheet.cat, sheet.data), 
                                          sheet_nm)
            break
        case 3:
            XLSX.utils.book_append_sheet(workbook, 
                                          this.newSheet4TopRankKeywords(sheet.cat, sheet.data), 
                                          sheet_nm)
            break
      }
    }

    // 엑셀 → ArrayBuffer 변환
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Blob으로 변환 후 FormData에 담아 전송
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const file_nm = 'insight_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

    const formData = new FormData();
    formData.append('file', blob, file_nm);
    formData.append('filename', file_nm); // 저장 경로 전달

    const response = await AiAgentService.callAiAgent_SaveExcel(formData, source)

    if(response && response.status == 200)
      return response.data.data.path
      // return response.data.path // for local test
    else
      return ""
  }
}